import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import './Timeline.css';

interface TimelineEvent {
  id: number;
  year: string;
  title: string;
  description: string;
  icon: string;
  iconImage?: string;
}

const Timeline: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const events: TimelineEvent[] = [
    {
      id: 1,
      year: '2003',
      title: '开启公益之路',
      description: '创始人开始公益实践',
      icon: '🌱',
    },
    {
      id: 2,
      year: '2015',
      title: '妈妈益呀成立',
      description: '公益项目创立',
      icon: '💝',
    },
    {
      id: 3,
      year: '2019',
      title: '高帝思公司建立',
      description: '公司正式成立',
      icon: '🏢',
    },
    {
      id: 4,
      year: '2021',
      title: '心灵游乐场开业',
      description: '艺术疗愈体验中心开业',
      icon: '🎮',
      iconImage: '/images/chenyannan1976___源文件(1).png',
    },
    {
      id: 5,
      year: '2022',
      title: '艺术心理教育联盟启动',
      description: '联盟正式启动',
      icon: '🤝',
      iconImage: '/images/alliance_logo.webp',
    },
    {
      id: 6,
      year: '2023',
      title: '情绪游乐场开幕',
      description: '情绪管理中心开幕',
      icon: '🎨',
    },
    {
      id: 7,
      year: '2025',
      title: '少年未来岛启幕',
      description: '创新教育基地启幕',
      icon: '🏝️',
      iconImage: '/images/未来岛logo.png',
    },
    {
      id: 8,
      year: '2025',
      title: 'LOMILOLA品牌系列产品上市',
      description: '艺术疗愈产品上市',
      icon: '✨',
      iconImage: '/images/lomilola.jpg',
    },
  ];

  return (
    <section id="timeline" className="timeline-section">
      <div className="timeline-container" ref={ref}>
        <div className={`section-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">发展历程</h2>
          <p className="section-subtitle">
            近20年专注于艺术心理教育，为心理健康事业不断努力
          </p>
        </div>

        <div className="timeline">
          {events.map((event, index) => (
            <div
              key={event.id}
              className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'} ${isVisible ? 'visible' : ''
              }`}
              style={{ transitionDelay: `${index * 0.15}s` }}
            >
              <div className="timeline-content">
                <div className="timeline-meta">
                  {event.iconImage ? (
                    <img src={event.iconImage} alt={event.title} className="timeline-icon-image" />
                  ) : (
                    <span className="timeline-icon">{event.icon}</span>
                  )}
                  <span className="timeline-year">{event.year}</span>
                </div>
                <h3 className="timeline-title">{event.title}</h3>
                <p className="timeline-description">{event.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Timeline;
